import dynamic from "next/dynamic";
import PageContextWrapper from "@components/Components/Reusables/PageContextWrapper";
import { handleRateLimit } from "utils/handleRateLimit";
import { getClientIp } from "utils/requestHelpers";
import PageHead from "@components/Components/Reusables/PageHead";

const ShowcaseLayout = dynamic(() => import("../js/Components/Showcase/ShowcaseLayout"));
const ShowcaseLayout2 = dynamic(() => import("../js/Components/Showcase/ShowcaseLayout2"));

//Dynamically load the home component and return it
const gallery = ({ data }) => {
  const meta = {
    title: `${data?.template_page_content?.meta?.meta_title || 'Our Gallery'} - Page ${data.showcase.current_page}${data?.template_page_content?.meta?.meta_title ? '' : ' - ' + process.env.brand.brand_name}`,
    description: `${data?.template_page_content?.meta?.meta_description || `${process.env.brand.brand_name} photo gallery for our clients. Our product range includes chairs to hire, conference furniture tables to hire, exhibition furniture hire, and office furniture hire`}`
  }

  return (
    <>
      <PageHead
        title={meta.title}
        description={meta.description}
        ogTitle={meta.og_title}
        ogDescription={meta.og_description}
        ogUrl={meta.og_url}
        ogType={meta.og_type}
        ogImage={meta.og_image}
      />
      <PageContextWrapper
        page='showcase'
        page_content={data.template_page_content}
      >
        <ShowcaseLayout {...data} />
      </PageContextWrapper>
      {/* <ShowcaseLayout2 {...data}/>  */}
    </>
  );
};



export async function getServerSideProps({ req, res, query }) {
  const exactSlug = query.slug;
  let exactRoute = query.route;
  let per_page = query?.per_page ? '&per_page=' + query.per_page : '';

  const { headers } = getClientIp(req);

  try {
    const page = !query.page ? 1 : query.page;
    const apiReq = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}showcase?type=gallery&page=${page}${per_page}`, { headers });

    let data = null;

    try {
      data = await apiReq.json();
    } catch (error) {
      console.error('Invalid API response:', error);
    }

    const rateLimitRedirect = handleRateLimit(res, apiReq, data);
    if (rateLimitRedirect) return rateLimitRedirect;

    if (!data || data?.status == 'failed' || data?.exception) {
      return { notFound: true }
    }

    res.setHeader(
      'Cache-Control',
      'public, s-maxage=43200, stale-while-revalidate=59'
    );

    return {
      props: {
        data
      }
    };

  } catch (error) {
    return {
      props: {}
    }
  }
}

export default gallery;
